import { useZeroWorkspace } from "@/lib/zero"

export const PRODUCTLANE_WORKSPACE_NAME = "Productlane"

/**
 * Whether this is our own workspace, used to gate features we are still
 * dogfooding. Matching on the name means a customer who happens to name their
 * workspace Productlane sees them too, which is acceptable for a soft gate but
 * not for anything that has to stay private.
 *
 * Undefined until Zero delivers the workspace row, so effects that reset
 * persisted state can wait instead of firing on a cold load.
 */
export function useIsProductlaneWorkspace(): boolean | undefined {
	const workspace = useZeroWorkspace()
	if (workspace === undefined) return undefined
	return workspace.name === PRODUCTLANE_WORKSPACE_NAME
}
